/** value type — ProjectTypeEnum бэкенда; stage — ProjectStageEnum (1…6). */
export const PROJECTS_FILTRATION = {
    TYPE_PROJECT: [
        { label: "Все", value: "all" },
        { label: "Единоразовый", value: "one_time" },
        { label: "Циклический", value: "cyclical" },
    ] as const,

    STAGE_PROJECT: [
        { label: "Все этапы", value: "all" },
        { label: "Идея", value: "1" },
        { label: "Планирование", value: "2" },
        { label: "В реализации", value: "3" },
        { label: "Отладка", value: "4" },
        { label: "Работает", value: "5" },
        { label: "Завершён", value: "6" },
    ] as const,
}